import { isObject, isString } from '../../../utils/lang';
var FallbackDiscardReason;
(function (FallbackDiscardReason) {
    FallbackDiscardReason["FlagName"] = "Invalid flag name (max 100 chars, no spaces)";
    FallbackDiscardReason["Treatment"] = "Invalid treatment (max 100 chars and must match pattern)";
})(FallbackDiscardReason || (FallbackDiscardReason = {}));
var TREATMENT_PATTERN = /^[0-9]+[.a-zA-Z0-9_-]*$|^[a-zA-Z]+[a-zA-Z0-9_-]*$/;
export function isValidFlagName(name) {
    return name.length <= 100 && !name.includes(' ');
}
export function isValidTreatment(t) {
    var treatment = isObject(t) ? t.treatment : t;
    if (!isString(treatment) || treatment.length > 100) {
        return false;
    }
    return TREATMENT_PATTERN.test(treatment);
}
function sanitizeGlobal(logger, treatment) {
    if (treatment === undefined)
        return undefined;
    if (!isValidTreatment(treatment)) {
        logger.error("Fallback treatments - Discarded fallback: " + FallbackDiscardReason.Treatment);
        return undefined;
    }
    return treatment;
}
function sanitizeByFlag(logger, byFlagFallbacks) {
    var sanitizedByFlag = {};
    if (!isObject(byFlagFallbacks))
        return sanitizedByFlag;
    Object.keys(byFlagFallbacks).forEach(function (flag) {
        var t = byFlagFallbacks[flag];
        if (!isValidFlagName(flag)) {
            logger.error("Fallback treatments - Discarded flag '" + flag + "': " + FallbackDiscardReason.FlagName);
            return;
        }
        if (!isValidTreatment(t)) {
            logger.error("Fallback treatments - Discarded treatment for flag '" + flag + "': " + FallbackDiscardReason.Treatment);
            return;
        }
        sanitizedByFlag[flag] = t;
    });
    return sanitizedByFlag;
}
export function sanitizeFallbacks(logger, fallbacks) {
    if (!isObject(fallbacks)) {
        logger.error('Fallback treatments - Discarded configuration: it must be an object with optional `global` and `byFlag` properties');
        return;
    }
    return {
        global: sanitizeGlobal(logger, fallbacks.global),
        byFlag: sanitizeByFlag(logger, fallbacks.byFlag)
    };
}
